import HttpService from "../../../../services/HttpService";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const axiosClient = HttpService.getAxiosClient();

const assertApiBaseUrl = () => {
  if (!API_BASE_URL) {
    throw new Error("REACT_APP_API_BASE_URL is not configured.");
  }
};

export const getProductTypes = async ({ dataUploadId, limit = 100, offset = 0 }) => {
  assertApiBaseUrl();

  const response = await axiosClient.get("/feature-based/getProductTypes", {
    params: {
      data_upload_id: dataUploadId,
      limit,
      offset,
    },
  });

  return response.data;
};

export const getFeatureFilters = async ({
  dataUploadId,
  productType,
  selectedFilters = {},
}) => {
  assertApiBaseUrl();

  const response = await axiosClient.post("/feature-based/getFeatureFilters", {
    data_upload_id: dataUploadId,
    product_type: productType,
    selected_filters: selectedFilters,
  });

  return response.data;
};

export const getFeatureMatchingSkus = async ({
  dataUploadId,
  productType,
  filters = {},
  limit = 500,
  offset = 0,
}) => {
  assertApiBaseUrl();
  const response = await axiosClient.post("/feature-based/getFeatureMatchingSkus", {
    data_upload_id: dataUploadId,
    product_type: productType,
    filters,
    limit,
    offset,
  });

  return response.data;
};

export const getFeatureCombinations = async ({
  dataUploadId,
  productType,
  baseFilters = {},
  limit = 50,
  offset = 0,
}) => {
  assertApiBaseUrl();
  const response = await axiosClient.post("/feature-based/getFeatureCombinations", {
    data_upload_id: dataUploadId,
    product_type: productType,
    base_filters: baseFilters,
    limit,
    offset,
  });

  return response.data;
};
